function getOptionsList(options) {
    return typeof options === 'function' ? options() : options
}

export function resolveStateFromPostal(postalState, statesOptions) {
    const allStates = getOptionsList(statesOptions) || []
    if (!postalState) {
        return null
    }

    return allStates.find(
        (item) => item.value == postalState || item.label == postalState
    ) || null
}

export function getCountiesForState(stateCode, countiesOptions, statesOptions) {
    const allCounties = getOptionsList(countiesOptions) || []
    if (!allCounties.length || !stateCode) {
        return []
    }

    const allStates = getOptionsList(statesOptions) || []
    const stateOption = allStates.find(
        (item) => item.value == stateCode || item.label == stateCode
    )
    const normalizedCode = stateOption?.value ?? stateCode

    return allCounties.filter(
        (item) => item.state == normalizedCode || item.state == stateCode
    )
}

export function resolveCountyInList(county, countiesForState) {
    if (!county) {
        return null
    }

    if (!countiesForState?.length) {
        return county
    }

    return countiesForState.find((item) => item.value == county.value) ?? county
}

export function resolveCountyFromPostal(postalInformation, countiesForState) {
    if (!postalInformation || !countiesForState?.length) {
        return null
    }

    if (postalInformation.county_id != null && postalInformation.county_id !== '') {
        const byId = countiesForState.find((item) => item.value == postalInformation.county_id)
        if (byId) {
            return byId
        }
    }

    // API returns county id as country_id for some zips
    if (postalInformation.country_id != null && postalInformation.country_id !== '') {
        const byCountryId = countiesForState.find((item) => item.value == postalInformation.country_id)
        if (byCountryId) {
            return byCountryId
        }
    }

    const countyName = postalInformation.county || postalInformation.county_name
    if (countyName) {
        const normalizedName = `${countyName}`.trim().toLowerCase()
        return countiesForState.find((item) => (
            `${item.label ?? ''}`.trim().toLowerCase() === normalizedName ||
            `${item.name ?? ''}`.trim().toLowerCase() === normalizedName
        )) || null
    }

    return null
}

export function applyPostalInformation({
    postalInformation,
    previousState,
    previousCounty,
    statesOptions,
    countiesOptions,
}) {
    const state = resolveStateFromPostal(postalInformation.state, statesOptions)
    const stateCode = state?.value ?? postalInformation.state
    const countiesForState = getCountiesForState(stateCode, countiesOptions, statesOptions)
    const resolvedCounty = resolveCountyFromPostal(postalInformation, countiesForState)
    const stateChanged = `${previousState ?? ''}` !== `${stateCode ?? ''}`

    let county = resolvedCounty
    if (!county) {
        if (stateChanged) {
            county = null
        } else {
            county = resolveCountyInList(previousCounty, countiesForState)
        }
    }

    return {
        state,
        city: postalInformation.city ?? null,
        counties: countiesForState,
        county,
        stateChanged,
    }
}

export function applyPostalFormState({
    result,
    setSelectedState,
    setSelectedCity,
    setCounties,
    setSelectedcounty,
}) {
    const COUNTIES_DELAY_MS = 200

    setSelectedState(result.state)
    setSelectedCity(result.city)

    if (result.stateChanged) {
        setSelectedcounty(null)
        setCounties(null)
    }

    window.setTimeout(() => {
        const counties = result.counties ?? []
        const county = resolveCountyInList(result.county, counties)

        setCounties(counties.length ? counties : null)
        setSelectedcounty(county)
    }, COUNTIES_DELAY_MS)
}

export function applyManualStateChange({
    stateValue,
    stateOption,
    setCounties,
    setSelectedState,
    setSelectedcounty,
    countiesOptions,
    statesOptions,
}) {
    setSelectedcounty(null)
    setCounties(null)
    setSelectedState(stateOption)

    const counties = getCountiesForState(stateValue, countiesOptions, statesOptions)

    window.setTimeout(() => {
        setCounties(counties.length ? counties : null)
    }, 200)
}
